export const METASEARCH_PROPERTY_BLACKLIST_COOKIE = 'msBlacklist'
export const ENTRY_TTL_MS = 60 * 60 * 1000 // 1 hour

export type MetasearchBlacklist = Record<string, number>

/** Removes expired entries from a blacklist object. */
function pruneExpired(blacklist: MetasearchBlacklist): MetasearchBlacklist {
  const now = Date.now()
  const result: MetasearchBlacklist = {}
  for (const [id, timestamp] of Object.entries(blacklist)) {
    if (now - timestamp < ENTRY_TTL_MS) {
      result[id] = timestamp
    }
  }
  return result
}

export function parseBlacklist(cookieValue: string | undefined): MetasearchBlacklist {
  if (!cookieValue) return {}
  try {
    return pruneExpired(JSON.parse(cookieValue))
  } catch {
    return {}
  }
}

export function isPropertyBlacklisted(blacklist: MetasearchBlacklist, propertyId: string): boolean {
  const timestamp = blacklist[propertyId]
  if (timestamp === undefined) return false
  return Date.now() - timestamp < ENTRY_TTL_MS
}

export function addPropertyToBlacklist(blacklist: MetasearchBlacklist, propertyId: string): MetasearchBlacklist {
  return {
    ...pruneExpired(blacklist),
    [propertyId]: Date.now(),
  }
}

export function serializeBlacklist(blacklist: MetasearchBlacklist): string {
  return JSON.stringify(blacklist)
}
